import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  Modal,
  Form,
  Input,
  Select,
  Button,
  Radio,
  Row,
  Col,
  Space,
  DatePicker,
  Upload,
  notification,
  InputNumber,
  Switch,
  Collapse,
  message,
} from "antd";
import {
  DeleteFilled,
  PlusCircleFilled,
  PlusOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {} from "@ant-design/icons";
import _ from "lodash";
import axios from "axios";
import config from "../../config.js";
import { v4 as uuidv4 } from "uuid";
import { connect } from "react-redux";
import { Redirect, Route, Router, Link } from "react-router-dom";
import moment from "moment";
import ImageCompressor from "image-compressor";
// import { updateDoctortDetail , updateDoctorDetailResetState} from '../../action/updateDoctorDetailAction'
import { updateDoctorDetail } from "../../action/updateDoctorDetailAction";
import { updateDoctorDetailResetState } from "../../action/updateDoctorDetailAction";
import {
  resetPassword,
  resetPasswordResetState,
  RESET_PASSWORD,
} from "../../action/resetPasswordAction";
import {
  getCommonMasterList,
  getCommonMasterListReset,
} from "../../action/getCommonMasterListAction";

//style
import { ProfileBlankSpace } from "./ProfileSettingStyle";
import PageContainer from "./../../component/PageContainer/PageContainer";
import "./ProfileSetting.css";

//API
import {
  getDoctorDetail,
  getDoctorDetailReset,
  GET_DOCTOR_DETAIL,
} from "../../action/getDoctorDetailAction";

import {
  s3_cdn,
  getS3SingedUrl,
  validateImageFile,
  getDoctorToken,
} from "../../utils";
import { useContext } from "react";
import HeaderContext from "../../context/HeaderContext";

const inputField = {
  width: "100%",
  height: "45px",
  marginBottom: "7px",
  borderRadius: "10px",
};

const inputField2 = {
  width: "100%",
  height: "45px",
  marginBottom: "7px",
  borderRadius: "10px",
};

const { Option } = Select;
const RadioGroup = Radio.Group;
const { RangePicker } = DatePicker;
const dateFormat = "DD-MMM-YYYY";
const { Panel } = Collapse;
const layout = {};

const ProfileSetting = (props) => {
  const {
    getDoctorDetail,
    getDoctorDetailState,
    getDoctorDetailReset,
    updateDoctorDetail,
    updateDoctorDetailResetState,
    updateDoctorDetailState,
    getCommonMasterList,
    getCommonMasterListReset,
    getCommonMasterListState,
    resetPasswordState,
    resetPassword,
    resetPasswordResetState,
  } = props;

  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    email: "",
    mobile_number: "",
    dob: "",
    gender: "",
    // adhaar_number: "",
    // pan_card_number: "",
    // fmf_code: "",
    // pndt_registration: "",
    // mci_registration_number: "",
    // date_of_anniversary: "",
    // biography: "",
    // clinic_name: "",
    // clinic_address_line1: "",
    // clinic_address_line2: "",
    // clinic_city: "",
    // clinic_state: "",
    // clinic_country: "",
    // clinic_postal_code: "",
    // home_address_line1: "",
    // home_address_line2: "",
    city: "",
    state: "",
    // district: "",
    // country: "",
    pincode: "",
    // facebook_id: "",
    // instagram_id: "",
    // linkedin_id: "",
    // awards: [],
    // degree: [],
    // experience: [],
    // fmf_license_validity_date_from: "",
    // fmf_license_validity_date_to: "",
    // pndt_registration_validity_date_to: "",
    // pndt_registration_validity_date_to: "",
    // is_dcp_activated: "No",
    // type: "",
    // qualification: "",
    exprience: "",
    profile_picture: "",
    profile_picture_changed: "",
    // description: "",
    // tier_1_fee: "",
    // tier_2_fee: "",
    // area_of_expertise: "",
    // core_area: "",
    // can_give_medicine: "",
    // self_fee: "",
    // couple_fee: "",
    // family_fee: "",
    // medicine_fee: "",
    // hidden: "",
    // short_description: "",
    // interests: "",
    // expert_type: "",
    // consultation_type: "",
    // concerns: [],
    // expert_approaches: [],
    language: [],
    speciality: [],
  });

  const [form2Data, setForm2Data] = useState({
    password: "",
    newPassword1: "",
    newPassword2: "",
  });

  const [imageFile, setImageFile] = useState({
    fileName: null,
    isChanged: false,
    edit: true,
  });
  const [pictureModal, setPictureModal] = useState(false);
  const [redirect, setRedirect] = useState([false, ""]);
  const [form] = Form.useForm();
  const [form2] = Form.useForm();

  const [renderForm, setRenderForm] = useState(""); // loading, ideal, error
  const [isModalVisible, setIsModalVisible] = useState(false);
  const mode = "edit";
  const { setTitle } = useContext(HeaderContext);
  setTitle("Profile");
  //function
  // const reset = () => {
  //   <Route exact path="ProfileSetting/ResetPassword"/>
  //   }
  useEffect(() => {
    getCommonMasterList({
      slug: "practice-type,area-of-expertise,salutation,language,expert-type,consultation-type,concerns,expert-approaches,core-area",
    });
    return () => {
      getCommonMasterListReset();
    };
  }, []);
  useEffect(() => {
    if (getDoctorDetailState.apiState === "success") setRenderForm("ideal");
    if (getDoctorDetailState.apiState === "loading") setRenderForm("loading");
    if (getDoctorDetailState.apiState === "error") setRenderForm("error");
  }, [getDoctorDetailState.apiState]);

  useEffect(() => {
    if (getDoctorDetailState.apiState === "success") {
      setFormData({
        ...formData,
        ["fname"]: getDoctorDetailState.data.fname,
        ["lname"]: getDoctorDetailState.data.lname,
        ["email"]: getDoctorDetailState.data.email,
        ["mobile_number"]: getDoctorDetailState.data.mobile_number,
        ["dob"]: getDoctorDetailState.data.dob,
        ["gender"]: getDoctorDetailState.data.gender,
        // ["adhaar_number"]: getDoctorDetailState.data.adhaar_number,
        // ["pan_card_number"]: getDoctorDetailState.data.pan_card_number,
        // ["fmf_code"]: getDoctorDetailState.data.fmf_code,
        // ["pndt_registration"]: getDoctorDetailState.data.pndt_registration,
        // ["mci_registration_number"]:
        // getDoctorDetailState.data.mci_registration_number,
        // ["date_of_anniversary"]: getDoctorDetailState.data.date_of_anniversary,
        // ["biography"]: getDoctorDetailState.data.biography,
        // ["clinic_name"]: getDoctorDetailState.data.clinic_name,
        // ["clinic_address_line1"]:
        // getDoctorDetailState.data.clinic_address_line1,
        // ["clinic_address_line2"]:
        // getDoctorDetailState.data.clinic_address_line2,
        // ["clinic_city"]: getDoctorDetailState.data.clinic_city,
        // ["clinic_state"]: getDoctorDetailState.data.clinic_state,
        // ["clinic_country"]: getDoctorDetailState.data.clinic_country,
        // ["clinic_postal_code"]: getDoctorDetailState.data.clinic_postal_code,
        // ["home_address_line1"]: getDoctorDetailState.data.home_address_line1,
        // ["home_address_line2"]: getDoctorDetailState.data.home_address_line2,
        ["city"]: getDoctorDetailState.data.city,
        ["state"]: getDoctorDetailState.data.state,
        // ["country"]: getDoctorDetailState.data.country,
        ["pincode"]: getDoctorDetailState.data.pincode,
        // ["facebook_id"]: getDoctorDetailState.data.facebook_id,
        // ["instagram_id"]: getDoctorDetailState.data.instagram_id,
        // ["linkedin_id"]: getDoctorDetailState.data.linkedin_id,
        // ["degree"]: getDoctorDetailState.data.degree
        // ? getDoctorDetailState.data.degree
        // : [],
        // ["awards"]: getDoctorDetailState.data.awards
        // ? getDoctorDetailState.data.awards
        // : [],
        // ["experience"]: getDoctorDetailState.data.experience
        // ? getDoctorDetailState.data.experience
        // : [],
        // ["fmf_license_validity_date_from"]:
        // getDoctorDetailState.data.fmf_license_validity_date_from,
        // ["fmf_license_validity_date_to"]:
        // getDoctorDetailState.data.fmf_license_validity_date_to,
        // ["pndt_registration_validity_date_from"]:
        // getDoctorDetailState.data.pndt_registration_validity_date_from,
        // ["pndt_registration_validity_date_to"]:
        // getDoctorDetailState.data.pndt_registration_validity_date_to,
        // ["is_dcp_activated"]: getDoctorDetailState.data.is_dcp_activated,
        // ["is_dcp_activated"]: getDoctorDetailState.data.is_dcp_activated,
        // ["type"]: getDoctorDetailState.data.type,
        // ["qualification"]: getDoctorDetailState.data.qualification,
        ["exprience"]: getDoctorDetailState.data.exprience ? moment().diff(getDoctorDetailState.data.exprience, 'years') : "NA",
        ["profile_picture"]: getDoctorDetailState.data.profile_picture,
        ["profile_picture_changed"]: false,
        // ["description"]: getDoctorDetailState.data.description,
        // ["tier_1_fee"]: getDoctorDetailState.data.tier_1_fee,
        // ["tier_2_fee"]: getDoctorDetailState.data.tier_2_fee,
        // ["area_of_expertise"]: getDoctorDetailState.data.area_of_expertise
        // ? getDoctorDetailState.data.area_of_expertise._id
        // : null,
        // ["core_area"]: getDoctorDetailState.data.core_area
        // ? getDoctorDetailState.data.core_area._id
        // : null,
        // ["can_give_medicine"]: getDoctorDetailState.data.can_give_medicine,
        // ["self_fee"]: getDoctorDetailState.data.self_fee,
        // ["couple_fee"]: getDoctorDetailState.data.couple_fee,
        // ["family_fee"]: getDoctorDetailState.data.family_fee,
        // ["medicine_fee"]: getDoctorDetailState.data.medicine_fee,
        // ["hidden"]: getDoctorDetailState.data.hidden,
        // ["short_description"]: getDoctorDetailState.data.short_description,
        // ["interests"]: getDoctorDetailState.data.interests,
        // ["expert_type"]:
        // getDoctorDetailState.data.expert_type &&
        // getDoctorDetailState.data.expert_type._id,
        // ["consultation_type"]:
        // getDoctorDetailState.data.consultation_type &&
        // getDoctorDetailState.data.consultation_type._id,
        // ["concerns"]:
        // getDoctorDetailState.data.concerns &&
        // getDoctorDetailState.data.concerns.map((obj) => obj._id),
        // ["expert_approaches"]:
        // getDoctorDetailState.data.expert_approaches &&
        // getDoctorDetailState.data.expert_approaches.map((obj) => obj._id),
        ["language"]: getDoctorDetailState.data.language.map((obj) => obj._id),
        ["speciality"]: getDoctorDetailState.data.speciality.map(
          (obj) => obj.value
        ),
      });
      form.setFieldsValue({
        fname: getDoctorDetailState.data.fname,
        lname: getDoctorDetailState.data.lname,
        email: getDoctorDetailState.data.email,
        mobile_number: getDoctorDetailState.data.mobile_number,
        dob: getDoctorDetailState.data.dob
          ? moment(moment(getDoctorDetailState.data.dob), "DD/MM/YYYY")
          : "",
        // date_of_anniversary: getDoctorDetailState.data.date_of_anniversary
        //   ? moment(
        //       moment(getDoctorDetailState.data.date_of_anniversary),
        //       "DD/MM/YYYY"
        //     )
        //   : "",
        // fmf_license_date: [
        //   getDoctorDetailState.data.fmf_license_validity_date_from
        //     ? moment(
        //         moment(
        //           getDoctorDetailState.data.fmf_license_validity_date_from
        //         ),
        //         "DD/MM/YYYY"
        //       )
        //     : "",
        //   getDoctorDetailState.data.fmf_license_validity_date_to
        //     ? moment(
        //         moment(getDoctorDetailState.data.fmf_license_validity_date_to),
        //         "DD/MM/YYYY"
        //       )
        //     : "",
        // ],
        // pndt_registration_date: [
        //   getDoctorDetailState.data.pndt_registration_validity_date_from
        //     ? moment(
        //         moment(
        //           getDoctorDetailState.data.pndt_registration_validity_date_from
        //         ),
        //         "DD/MM/YYYY"
        //       )
        //     : "",
        //   getDoctorDetailState.data.pndt_registration_validity_date_to
        //     ? moment(
        //         moment(
        //           getDoctorDetailState.data.pndt_registration_validity_date_to
        //         ),
        //         "DD/MM/YYYY"
        //       )
        //     : "",
        // ],
        gender: getDoctorDetailState.data.gender,
        // adhaar_number: getDoctorDetailState.data.adhaar_number,
        // pan_card_number: getDoctorDetailState.data.pan_card_number,
        // fmf_code: getDoctorDetailState.data.fmf_code,
        // pndt_registration: getDoctorDetailState.data.pndt_registration,
        // mci_registration_number:
        //   getDoctorDetailState.data.mci_registration_number,
        // biography: getDoctorDetailState.data.biography,
        // clinic_name: getDoctorDetailState.data.clinic_name,
        // clinic_address_line1: getDoctorDetailState.data.clinic_address_line1,
        // clinic_address_line2: getDoctorDetailState.data.clinic_address_line2,
        // clinic_city: getDoctorDetailState.data.clinic_city,
        // clinic_state: getDoctorDetailState.data.clinic_state,
        // clinic_country: getDoctorDetailState.data.clinic_country,
        // clinic_postal_code: getDoctorDetailState.data.clinic_postal_code,
        // home_address_line1: getDoctorDetailState.data.home_address_line1,
        // home_address_line2: getDoctorDetailState.data.home_address_line2,
        city: getDoctorDetailState.data.city,
        state: getDoctorDetailState.data.state,
        // country: getDoctorDetailState.data.country,
        pincode: getDoctorDetailState.data.pincode,
        // facebook_id: getDoctorDetailState.data.facebook_id,
        // instagram_id: getDoctorDetailState.data.instagram_id,
        // linkedin_id: getDoctorDetailState.data.linkedin_id,
        // is_dcp_activated: getDoctorDetailState.data.is_dcp_activated,
        // type: getDoctorDetailState.data.type,
        // qualification: getDoctorDetailState.data.qualification,
        exprience:  getDoctorDetailState.data.exprience ? moment().diff(getDoctorDetailState.data.exprience, 'years') : "NA",
        profile_picture: getDoctorDetailState.data.profile_picture,
        // description: getDoctorDetailState.data.description,
        // tier_1_fee: getDoctorDetailState.data.tier_1_fee,
        // tier_2_fee: getDoctorDetailState.data.tier_2_fee,
        // area_of_expertise: getDoctorDetailState.data.area_of_expertise
        //   ? getDoctorDetailState.data.area_of_expertise._id
        //   : null,
        // core_area: getDoctorDetailState.data.core_area
        //   ? getDoctorDetailState.data.core_area._id
        //   : null,
        // can_give_medicine: getDoctorDetailState.data.can_give_medicine,
        // self_fee: getDoctorDetailState.data.self_fee,
        // couple_fee: getDoctorDetailState.data.couple_fee,
        // family_fee: getDoctorDetailState.data.family_fee,
        // medicine_fee: getDoctorDetailState.data.medicine_fee,
        // hidden: getDoctorDetailState.data.hidden,
        // short_description: getDoctorDetailState.data.short_description,
        // interests: getDoctorDetailState.data.interests,
        // expert_type:
        //   getDoctorDetailState.data.expert_type &&
        //   getDoctorDetailState.data.expert_type._id,
        // consultation_type:
        //   getDoctorDetailState.data.consultation_type &&
        //   getDoctorDetailState.data.consultation_type._id,
        // concerns: getDoctorDetailState.data.concerns.map((obj) => obj._id),
        // expert_approaches: getDoctorDetailState.data.expert_approaches.map(
        //   (obj) => obj._id
        // ),
        language: getDoctorDetailState.data.language.map((obj) => obj._id),
        speciality: getDoctorDetailState.data.speciality.map(
          (obj) => obj.value
        ),
      });

      // let degree = {};
      // if (getDoctorDetailState.data.degree) {
      //   getDoctorDetailState.data.degree.map((data, ind) => {
      //     degree = Object.assign(
      //       { [`degree[${ind}].degree_name`]: data.degree_name },
      //       { [`degree[${ind}].college_name`]: data.college_name },
      //       { [`degree[${ind}].year`]: data.year ? moment(data.year) : "" }
      //     );
      //     form.setFieldsValue(degree);
      //   });
      // }
      // let awards = {};
      // if (getDoctorDetailState.data.awards) {
      //   getDoctorDetailState.data.awards.map((data, ind) => {
      //     awards = Object.assign(
      //       { [`awards[${ind}].award`]: data.award },
      //       { [`awards[${ind}].year`]: data.year ? moment(data.year) : "" }
      //     );
      //     form.setFieldsValue(awards);
      //   });
      // }
      let experience = {};
      if (getDoctorDetailState.data.experience) {
        getDoctorDetailState.data.experience.map((data, ind) => {
          experience = Object.assign(
            { [`experience[${ind}].hospital_name`]: data.hospital_name },
            { [`experience[${ind}].institute`]: data.institute },
            {
              [`experience[${ind}].year`]: [
                data.start_date
                  ? moment(moment(data.start_date), "DD/MM/YYYY")
                  : "",
                data.end_date
                  ? moment(moment(data.end_date), "DD/MM/YYYY")
                  : "",
              ],
            }
          );
          form.setFieldsValue(experience);
        });
      }
    }
  }, [getDoctorDetailState]);

  useEffect(() => {
    getDoctorDetail();
  }, [getDoctorDetail]);

  //update doc details
  useEffect(() => {
    if (updateDoctorDetailState.apiState === "success") {
      updateDoctorDetailResetState();
      setRedirect([true, "/ProfileSetting"]);
      notification["success"]({
        message: updateDoctorDetailState.message,
      });
    }
    if (updateDoctorDetailState.apiState === "error") {
      updateDoctorDetailResetState();
      notification["error"]({
        message: updateDoctorDetailState.message,
        placement: "topRight",
      });
    }
  }, [updateDoctorDetailState]);

  //reset password

  useEffect(() => {
    if (resetPasswordState.apiState === "success") {
      setForm2Data({
        ...form2Data,
        ["password"]: resetPasswordState.data.password,
        ["newPassword1"]: resetPasswordState.data.newPassword1,
        ["newPassword2"]: resetPasswordState.data.newPassword2,
      });

      form.setFieldsValue({
        password: resetPasswordState.data.password,
        newPassword1: resetPasswordState.data.newPassword1,
        newPassword2: resetPasswordState.data.newPassword2,
      });
    }
  }, [resetPasswordState]);

  useEffect(() => {
    if (resetPasswordState.apiState === "success") {
      resetPasswordResetState();
      setRedirect([true, "/ProfileSetting"]);
      notification["success"]({
        message: resetPasswordState.message,
      });
    }
    if (resetPasswordState.apiState === "error") {
      resetPasswordResetState();
      notification["error"]({
        message: resetPasswordState.message,
        placement: "topRight",
      });
    }
  }, [resetPasswordState]);

  const onFinish = async () => {
    setImageFile({ ...imageFile, fileName: null });
    try {
      if (imageFile.isChanged) {
        let imagefilename = uuidv4();
        let imageValidationRes = validateImageFile(imageFile.fileName);
        if (imageValidationRes.status) {
          let s3UrlResImage = await getS3SingedUrl(
            imagefilename,
            imageValidationRes.ext,
            imageFile.fileName,
            "doctor"
          );
          await axios.put(s3UrlResImage.url, imageFile.fileName);
          formData.profile_picture = `${imagefilename}.${imageValidationRes.ext}`;
          formData.profile_picture_changed = true;
        } else {
          alert("Select image type JPG or PNG.");
          return;
        }
      } else {
        formData.profile_picture_changed = false;
      }
      await updateDoctorDetail(formData);
      await getDoctorDetail();
    } catch (error) {
      console.log(error);
    }
  };

  const onConfirm = () => {
    resetPassword(form2Data);
  };

  const handleDateChange = (name, date, dateString) => {
      setFormData({ ...formData, [name]: moment(date) });
  };

  const dochange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const dogenderchange = (e) => {
    console.log("e", e);
    setFormData({ ...formData, ["gender"]: e });
  };

  // Degree
  // const handleAddDegree = () => {
  //   const degree = [...formData.degree];
  //   degree.push({
  //     degree_name: "",
  //     college_name: "",
  //     year: "",
  //   });
  //   setFormData({ ...formData, ["degree"]: degree });
  // };
  // const handleOnChangeDegree = (e, index, name) => {
  //   const { value } = e.target;
  //   const list = [...formData.degree];
  //   list[index][name] = value;
  //   setFormData({ ...formData, ["degree"]: list });
  // };

  // const handleOnChangeDegreeYear = (date, dateString, index, name) => {
  //   const list = [...formData.degree];
  //   list[index][name] = dateString;
  //   setFormData({ ...formData, ["degree"]: list });
  // };
  // const handleOnRemoveDegreeRow = (index) => {
  //   const list = [...formData.degree];
  //   list.splice(index, 1);
  //   let degree = {};
  //   list.map((data, ind) => {
  //     degree = Object.assign(
  //       { [`degree[${ind}].degree_name`]: "" },
  //       { [`degree[${ind}].college_name`]: "" },
  //       { [`degree[${ind}].year`]: "" }
  //     );
  //     form.setFieldsValue(degree);
  //   });
  //   setFormData({ ...formData, ["degree"]: list });
  //   let degreeSet = {};
  //   list.map((data, ind) => {
  //     degreeSet = Object.assign(
  //       { [`degree[${ind}].degree_name`]: data.degree_name },
  //       { [`degree[${ind}].college_name`]: data.college_name },
  //       { [`degree[${ind}].year`]: data.year ? moment(data.year) : "" }
  //     );
  //     form.setFieldsValue(degreeSet);
  //   });
  // };
  // const handleOnRemoveAwardRow = (index) => {
  //   const list = [...formData.awards];
  //   list.splice(index, 1);
  //   let awards = {};
  //   list.map((data, ind) => {
  //     awards = Object.assign(
  //       { [`awards[${ind}].award`]: "" },
  //       { [`awards[${ind}].year`]: "" }
  //     );
  //     form.setFieldsValue(awards);
  //   });
  //   setFormData({ ...formData, ["awards"]: list });
  //   let awardSet = {};
  //   list.map((data, ind) => {
  //     awardSet = Object.assign(
  //       { [`awards[${ind}].award`]: data.award },
  //       { [`awards[${ind}].year`]: data.year ? moment(data.year) : "" }
  //     );
  //     form.setFieldsValue(awardSet);
  //   });
  // };
  // const handleOnRemoveExperienceRow = (index) => {
  //   const list = [...formData.experience];
  //   list.splice(index, 1);
  //   let experience = {};
  //   list.map((data, ind) => {
  //     experience = Object.assign(
  //       { [`experience[${ind}].hospital_name`]: data.hospital_name },
  //       { [`experience[${ind}].institute`]: data.institute },
  //       {
  //         [`experience[${ind}].year`]: [
  //           data.start_date
  //             ? moment(moment(data.start_date), "DD/MM/YYYY")
  //             : "",
  //           data.end_date ? moment(moment(data.end_date), "DD/MM/YYYY") : "",
  //         ],
  //       }
  //     );
  //     form.setFieldsValue(experience);
  //   });

  //   setFormData({ ...formData, ["experience"]: list });

  //   let experienceSet = {};
  //   list.map((data, ind) => {
  //     experienceSet = Object.assign(
  //       { [`experience[${ind}].hospital_name`]: data.hospital_name },
  //       { [`experience[${ind}].institute`]: data.institute },
  //       {
  //         [`experience[${ind}].year`]: [
  //           data.start_date
  //             ? moment(moment(data.start_date), "DD/MM/YYYY")
  //             : "",
  //           data.end_date ? moment(moment(data.end_date), "DD/MM/YYYY") : "",
  //         ],
  //       }
  //     );
  //     form.setFieldsValue(experienceSet);
  //   });
  // };

  // // Awards
  // const handleAddAward = () => {
  //   const awards = [...formData.awards];
  //   awards.push({
  //     award: "",
  //     year: "",
  //   });
  //   setFormData({ ...formData, ["awards"]: awards });
  // };
  // const handleOnChangeAward = (e, index, name) => {
  //   const { value } = e.target;
  //   const list = [...formData.awards];
  //   list[index][name] = value;
  //   setFormData({ ...formData, ["awards"]: list });
  // };

  // const handleOnChangeAwardYear = (date, dateString, index, name) => {
  //   const list = [...formData.awards];
  //   list[index][name] = dateString;
  //   setFormData({ ...formData, ["awards"]: list });
  // };
  // Experience
  const handleAddExperience = () => {
    const experience = [...formData.experience];
    experience.push({
      hospital_name: "",
      start_date: "",
      end_date: "",
      institute: "",
    });
    setFormData({ ...formData, ["experience"]: experience });
  };
  const handleOnChangeExperience = (e, index, name) => {
    const { value } = e.target;
    const list = [...formData.experience];
    list[index][name] = value;
    setFormData({ ...formData, ["experience"]: list });
  };

  const handleOnChangeExperienceYear = (date, dateString, index, name) => {
    const list = [...formData.experience];
    list[index]["start_date"] = dateString[0]
      ? moment(dateString[0]).format("YYYY-MM-DD")
      : "";
    list[index]["end_date"] = dateString[1]
      ? moment(dateString[1]).format("YYYY-MM-DD")
      : "";
    setFormData({ ...formData, ["experience"]: list });
  };

  const modalchange = (e) => {
    setForm2Data({ ...form2Data, [e.target.name]: e.target.value });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const hiddenFileInput = useRef(null);

  const handleDateRangeChangeFMF = (value, dateString) => {
    setFormData({
      ...formData,
      ["fmf_license_validity_date_from"]: dateString[0]
        ? moment(dateString[0]).format("YYYY-MM-DD")
        : "",
      ["fmf_license_validity_date_to"]: dateString[1]
        ? moment(dateString[1]).format("YYYY-MM-DD")
        : "",
    });
  };
  const handleDateRangeChangePNDT = (value, dateString) => {
    setFormData({
      ...formData,
      ["pndt_registration_validity_date_from"]: dateString[0]
        ? moment(dateString[0]).format("YYYY-MM-DD")
        : "",
      ["pndt_registration_validity_date_to"]: dateString[1]
        ? moment(dateString[1]).format("YYYY-MM-DD")
        : "",
    });
  };

  const handleSelectChange = (name, value, node) => {
    if (name === "type" && value === "GC") {
      setFormData({ ...formData, ["expert_type"]: "" });
    }
    if (name === "pincode") {
      if (value) {
        value = JSON.parse(value);
        setFormData({
          ...formData,
          ["pincode"]: value.pincode,
          ["city"]: value.taluk_name,
          ["district"]: value.district_name,
          ["state"]: value.state_name,
        });
        form.setFieldsValue({
          city: value.taluk_name,
          district: value.district_name,
          state: value.state_name,
        });
      } else {
        setFormData({
          ...formData,
          ["city"]: "",
          ["district"]: "",
          ["state"]: "",
        });
        form.setFieldsValue({
          city: "",
          district: "",
          state: "",
        });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleOnChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSwitchChange = (name, checked) => {
    setFormData({ ...formData, [name]: checked });
  };

  const handleNumberChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };
  const onChange = (key) => {
    if (key.length > 1) {
      key.splice(0, 1);
    }

    console.log(key);
  };

  const handleFileEdit = () => {
    setPictureModal(false);
    hiddenFileInput.current.click();
  };

  const compressImage = async (file) => {
    if (file.size <= 1024 * 1024) {
      return file;
    }

    try {
      const compressedImage = await ImageCompressor(file, {
        quality: 0.7,
        maxWidth: 1024,
      });
      return compressedImage;
    } catch (error) {
      message.error("Image compression error:", error);
      return file;
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      message.error("Image size should be less than 10MB.");
      e.target.value = null;
      return;
    }

    if (window.innerWidth < 768) {
      const compressedFile = await compressImage(file);
      e.target.files[0] = compressedFile;
    }

    setImageFile({
      fileName: file,
      isChanged: true,
      edit: false,
    });
  };

  const handleDeleteProfilePic = async () => {
    try {
      const response = await axios.post(
        `${config.api.base_url}doctor/remove-profile-pic`,
        {},
        {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${getDoctorToken()}`,
          },
        }
      );

      if (response.status === 200) {
        setImageFile({
          fileName: null,
          isChanged: false,
          edit: false,
        });
        setFormData({ ...formData, profile_picture: "" });
        message.success("Profile picture removed successfully.");
      } else {
        message.error(
          "Failed to remove profile picture. Please try again later."
        );
      }
    } catch (error) {
      message.error("An error occurred while deleting the profile picture.");
    }
    setPictureModal(false);
  };

  return (
    <>
      {redirect[0] && <Redirect to={redirect[1]} />}
      <PageContainer>
        <div className="ml-n3 mr-n3 pl-sm-0 mr-sm-0 ml-md-0 mr-md-0 ml-lg-0 mr-lg-0">
          <Form form={form} layout="vertical" onFinish={onFinish}>
            {/* <Collapse defaultActiveKey={["1"]} onChange={onChange}> */}
            {/* <Panel header="Basic Information" key="1"> */}
            {/* <Card bordered={true}> */}
            <Row gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="profile_picture"
                  rules={[
                    {
                      required:
                        formData.is_dcp_activated === "Yes"
                          ? mode === "edit" && imageFile.edit
                            ? formData.profile_picture
                              ? imageFile.isChanged
                              : !imageFile.isChanged
                            : !imageFile.isChanged
                          : imageFile.isChanged,
                      message: "Required",
                    },
                  ]}
                >
                  <div>
                    {mode === "edit" && (
                      <div
                        style={{
                          marginTop: 10,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {imageFile.fileName ? (
                          <img
                            className="profile-pic"
                            src={URL.createObjectURL(imageFile.fileName)}
                            alt={
                              process.env.PUBLIC_URL + "./images/Profile.svg"
                            }
                          />
                        ) : formData.profile_picture ? (
                          <img
                            className="profile-pic"
                            src={`${s3_cdn()}doctor/${
                              formData.profile_picture
                            }`}
                            alt={process.env.PUBLIC_URL + "/images/Profile.svg"}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src =
                                "/images/avatar_transgender.svg";
                            }}
                          />
                        ) : formData.gender ? (
                          formData.gender === "female" ? (
                            <img
                              className="profile-pic"
                              src="/images/svg/avatar_female.svg"
                              alt=""
                            />
                          ) : formData.gender === "male" ? (
                            <img
                              className="profile-pic"
                              src="/images/svg/avatar_male.svg"
                              alt=""
                            />
                          ) : (
                            <img
                              className="profile-pic"
                              src="images/svg/avatar_transgender.svg"
                              alt=""
                            />
                          )
                        ) : (
                          <img
                            className="profile-pic"
                            src="images/svg/avatar_transgender.svg"
                            alt=""
                          />
                        )}
                        <Button
                          type="link"
                          icon={<EditOutlined />}
                          className="edit-btn"
                          onClick={() => setPictureModal(true)}
                        />
                      </div>
                    )}
                    <input
                      type="file"
                      ref={hiddenFileInput}
                      onChange={handleFileChange}
                      accept="image/png, image/jpeg"
                      style={{ display: "none" }}
                      disabled={formData.is_dcp_activated === "No"}
                    />
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Modal
              visible={pictureModal}
              onCancel={() => setPictureModal(false)}
              footer={null}
            >
              <h4>Profile Picture</h4>
              <p>Select an option:</p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Button
                  type="primary"
                  style={{ width: "100%", marginBottom: 10 }}
                  onClick={handleFileEdit}
                >
                  Update profile picture
                </Button>
                <Button
                  style={{ width: "100%" }}
                  onClick={handleDeleteProfilePic}
                >
                  Delete profile picture
                </Button>
              </div>
            </Modal>
            <Row gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="fname"
                  label="First Name"
                  // rules={[
                  //   { required: true, message: "Required" },
                  //   {
                  //     pattern: "",
                  //     message: "Name is not valid",
                  //   },
                  // ]}
                >
                  <Input
                    name="fname"
                    placeholder="Enter name"
                    onChange={dochange}
                    style={inputField}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="lname"
                  label="Last Name"
                  // rules={[
                  //   { required: true, message: "Required" },
                  //   {
                  //     pattern: "",
                  //     message: "Name is not valid",
                  //   },
                  // ]}
                >
                  <Input
                    name="lname"
                    placeholder="Enter name"
                    onChange={dochange}
                    style={inputField}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  // rules={[
                  //   {
                  //     required: true,
                  //     type: "regexp",
                  //     pattern: new RegExp("^w+@[a-zA-Z_]+?.[a-zA-Z]{2,15}$"),
                  //     message: "Please enter a valid existing Email ID",
                  //   },
                  // ]}
                  label="Email"
                  name="email"
                >
                  <Input
                    name="email"
                    placeholder="enter mail id"
                    onChange={dochange}
                    style={inputField}
                    disabled={ 
                formData.email !== null && formData.email !== "" && !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(formData.email)
              }
                  ></Input>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  // rules={[
                  //   {
                  //     required: true,
                  //     type: "regexp",
                  //     pattern: new RegExp("^[6789]d{9}$"),
                  //     message: "Please enter a valid mobile number",
                  //   },
                  // ]}
                  label="Phone Number"
                  name="mobile_number"
                >
                  <Input
                    name="mobile_number"
                    placeholder="enter mobile number"
                    onChange={dochange}
                    style={inputField}
                    disabled={
                      formData.mobile_number
                        ? formData.mobile_number.length === 10 &&
                          /^\d+$/.test(formData.mobile_number) &&
                          /^([6-9]\d{9})$/.test(formData.mobile_number)
                        : false
                    }
                  ></Input>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label=" Date of Birth"
                  name="dob"
                  // rules={[{ required: true, message: "Required" }]}
                >
                  <DatePicker
                    name="dob"
                    placeholder="Birthdate"
                    onChange={(date, dateString) =>
                      handleDateChange("dob", date, dateString)
                    }
                    style={inputField}
                    format={"DD/MM/YYYY"}
                    disabled={formData.dob !== null}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item label="Gender" name="gender">
                  <Select style={inputField} onChange={dogenderchange} disabled={formData.gender !== null}>
                    <Option value="Male">Male</Option>
                    <Option value="Female">Female</Option>
                    <Option value="Others">Others</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            {/* Commented fields to match mobile doctor profile form */}

            {/* <Row gutter={24}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Form.Item
                        name="adhaar_number"
                        label="Aadhaar number"
                        rules={[
                          { required: true, message: "Required" },
                          {
                            pattern: "^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$",
                            message: "Aadhaar number is not valid",
                          },
                        ]}
                      >
                        <Input
                          name="adhaar_number"
                          placeholder="Enter Aadhar Number"
                          onChange={dochange}
                          style={inputField}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Form.Item
                        name="pan_card_number"
                        label="Pan Card Number"
                        rules={[
                          { required: true, message: "Required" },
                          {
                            pattern: "^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$",
                            message: "PAN is not valid",
                          },
                        ]}
                      >
                        <Input
                          name="pan_card_number"
                          placeholder="Enter PAN Number"
                          onChange={dochange}
                          style={inputField}
                        />
                      </Form.Item>
                    </Col>
                  </Row> */}
            {/* <Row gutter={24}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Form.Item
                        name="fmf_code"
                        label="Licence number"
                        rules={[
                          { required: true, message: "Required" },
                          {
                            pattern: "",
                            message: "not valid",
                          },
                        ]}
                      >
                        <Input
                          name="fmf_code"
                          placeholder="Enter Licence Number"
                          onChange={dochange}
                          style={inputField}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Form.Item
                        label="License Validity Date "
                        name="fmf_license_date"
                        rules={[{ required: true, message: "Required" }]}
                      >
                        <RangePicker
                          name="fmf_license_date"
                          placeholder={["Date From", "Date To"]}
                          onChange={handleDateRangeChangeFMF}
                          style={inputField}
                          format={"DD-MMM-YYYY"}
                        />
                      </Form.Item>
                    </Col>
                  </Row> */}
            {/* <Row gutter={24}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Form.Item
                        name="pndt_registration"
                        label="Registration number"
                        rules={[
                          { required: true, message: "Required" },
                          {
                            pattern: "",
                            message: "not valid",
                          },
                        ]}
                      >
                        <Input
                          name="pndt_registration"
                          placeholder="Enter Registration Number"
                          onChange={dochange}
                          style={inputField}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Form.Item
                        label="Registration Validity Date"
                        name="pndt_registration_date"
                      >
                        <RangePicker
                          name="pndt_registration_date"
                          placeholder={["Date From", "Date To"]}
                          onChange={handleDateRangeChangePNDT}
                          style={inputField}
                          format={"DD-MMM-YYYY"}
                        />
                      </Form.Item>
                    </Col>
                  </Row> */}
            {/* <Row gutter={24}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Form.Item
                        name="mci_registration_number"
                        label="MCI Registration Number"
                        rules={[
                          { required: true, message: "Required" },
                          {
                            pattern: "",
                            message: "not valid",
                          },
                        ]}
                      >
                        <Input
                          name="mci_registration_number"
                          placeholder="Enter MCI Registration Number"
                          onChange={dochange}
                          style={inputField}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Form.Item
                        label="Date of Anniversary"
                        name="date_of_anniversary"
                        rules={[{ required: true, message: "Required" }]}
                      >
                        <DatePicker
                          name="date_of_anniversary"
                          placeholder="Enter Anniversary date"
                          onChange={(date, dateString) =>
                            handleDateChange(
                              "date_of_anniversary",
                              date,
                              dateString
                            )
                          }
                          style={inputField}
                          format={"DD/MM/YYYY"}
                        />
                      </Form.Item>
                    </Col>
                  </Row> */}
            {/* </Card> */}
            {/* </Panel> */}
            {/* <Panel header="Contact Details & Address" key="2"> */}
            {/* <div> */}
            {/* <Card> */}
            {/* <div className="tils">Clinic Address</div> */}

            {/* <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Clinic Name"
                          name="clinic_name"
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: "",
                              message: "not valid",
                            },
                          ]}
                        >
                          <Input
                            name="clinic_name"
                            placeholder="Enter Clinic Name"
                            onChange={dochange}
                            style={inputField}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Address Line 1"
                          name="clinic_address_line1"
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: "",
                              message: "not valid",
                            },
                          ]}
                        >
                          <Input
                            name="clinic_address_line1"
                            placeholder="Address 1"
                            onChange={dochange}
                            style={inputField}
                          />
                        </Form.Item>
                      </Col>
                    </Row> */}
            {/* <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Address Line 2"
                          name="clinic_address_line2"
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: "",
                              message: "not valid",
                            },
                          ]}
                        >
                          <Input
                            name="clinic_address_line2"
                            placeholder="Address 2"
                            onChange={dochange}
                            style={inputField}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="City"
                          name="clinic_city"
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: "",
                              message: "not valid",
                            },
                          ]}
                        >
                          <Input
                            name="clinic_city"
                            placeholder="City"
                            onChange={dochange}
                            style={inputField}
                          />
                        </Form.Item>
                      </Col>
                    </Row> */}
            {/* <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="State / Province"
                          name="clinic_state"
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: "",
                              message: "not valid",
                            },
                          ]}
                        >
                          <Input
                            name="clinic_state"
                            placeholder="State / Province"
                            onChange={dochange}
                            style={inputField}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Country"
                          name="clinic_country"
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: "",
                              message: "not valid",
                            },
                          ]}
                        >
                          <Input
                            name="clinic_country"
                            placeholder="Country"
                            onChange={dochange}
                            style={inputField}
                          />
                        </Form.Item>
                      </Col>
                    </Row> */}
            {/* <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Postal Code"
                          name="clinic_postal_code"
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: "",
                              message: "not valid",
                            },
                          ]}
                        >
                          <Input
                            name="clinic_postal_code"
                            placeholder="Postal Code"
                            onChange={dochange}
                            style={inputField}
                          />
                        </Form.Item>
                      </Col>
                    </Row> */}
            {/* <div className="tils">Contact Details</div>s */}

            {/* <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Address Line 1"
                          name="home_address_line1"
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: "",
                              message: "not valid",
                            },
                          ]}
                        >
                          <Input
                            name="home_address_line1"
                            placeholder="Address Line 1"
                            onChange={dochange}
                            style={inputField}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Address Line 2"
                          name="home_address_line2"
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: "",
                              message: "not valid",
                            },
                          ]}
                        >
                          <Input
                            name="home_address_line2"
                            placeholder="Address Line 2"
                            onChange={dochange}
                            style={inputField}
                          />
                        </Form.Item>
                      </Col>
                    </Row> */}
            <Row gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="City"
                  name="city"
                  // rules={[
                  //   { required: true, message: "Required" },
                  //   {
                  //     pattern: "",
                  //     message: "not valid",
                  //   },
                  // ]}
                >
                  <Input
                    name="city"
                    placeholder="City"
                    onChange={dochange}
                    style={inputField}
                    readOnly
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="State / Province"
                  name="state"
                  // rules={[
                  //   { required: true, message: "Required" },
                  //   {
                  //     pattern: "",
                  //     message: "not valid",
                  //   },
                  // ]}
                >
                  <Input
                    name="state"
                    placeholder="State / Province"
                    onChange={dochange}
                    style={inputField}
                    readOnly
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Country"
                          name="country"
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: "",
                              message: "not valid",
                            },
                          ]}
                        >
                          <Input
                            name="country"
                            placeholder="Country"
                            onChange={dochange}
                            style={inputField}
                          />
                        </Form.Item>
                      </Col> */}

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Pincode"
                  name="pincode"
                  // rules={[
                  //   { required: true, message: "Required" },
                  //   {
                  //     pattern: "",
                  //     message: "not valid",
                  //   },
                  // ]}
                >
                  <Input
                    name="pincode"
                    placeholder="Postal Code"
                    onChange={dochange}
                    style={inputField}
                    disabled
                    // readOnly
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Language"
                  name="language"
                  rules={[
                    {
                      required: formData.is_dcp_activated === "Yes",
                      message: "Required",
                    },
                  ]}
                >
                  <Select
                    name="language"
                    placeholder="Select Language"
                    allowClear
                    onChange={(v, node) =>
                      handleSelectChange("language", v, node)
                    }
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    mode="multiple"
                    disabled={formData.is_dcp_activated === "No"}
                  >
                    {getCommonMasterListState.apiState === "success" &&
                      _.find(getCommonMasterListState.list, {
                        slug: "language",
                      }) && (
                        <>
                          {_.find(getCommonMasterListState.list, {
                            slug: "language",
                          }).common_master_detail.map((item) => (
                            <Select.Option value={item._id} key={item._id}>
                              {item.value}
                            </Select.Option>
                          ))}
                        </>
                      )}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            {/* </Card> */}
            {/* </div> */}
            {/* </Panel> */}
            {/* <Panel header="Biography/Degree/Awards/Experience" key="3">
                <div>
                  <Card>
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item
                          label="Biography"
                          name="biography"
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: "",
                              message: "not valid",
                            },
                          ]}
                        >
                          <Input.TextArea
                            style={{
                              width: "80%",
                              height: "120px",
                              borderRadius: "10px",
                            }}
                            name="biography"
                            placeholder="Biography"
                            onChange={dochange}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <div className="tils">Degree</div>
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        {formData.degree.map((data, index) => (
                          <Row gutter={24}>
                            <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                              <Form.Item
                                label="Degree"
                                name={`degree[${index}].degree_name`}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                              >
                                <Input
                                  name={`degree[${index}].degree_name`}
                                  value={data.degree_name}
                                  style={inputField2}
                                  placeholder="Degree"
                                  onChange={(e) =>
                                    handleOnChangeDegree(
                                      e,
                                      index,
                                      "degree_name"
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                              <Form.Item
                                label="College/Institute"
                                name={`degree[${index}].college_name`}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                              >
                                <Input
                                  name={`degree[${index}].college_name`}
                                  style={inputField2}
                                  placeholder="College/Institute"
                                  onChange={(e) =>
                                    handleOnChangeDegree(
                                      e,
                                      index,
                                      "college_name"
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                              <Form.Item
                                label="Year"
                                name={`degree[${index}].year`}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                              >
                                <DatePicker
                                  name={`degree[${index}].year`}
                                  onChange={(date, dateString) =>
                                    handleOnChangeDegreeYear(
                                      date,
                                      dateString,
                                      index,
                                      "year"
                                    )
                                  }
                                  picker="year"
                                  format="YYYY"
                                  style={inputField2}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                              <DeleteFilled
                                onClick={() => handleOnRemoveDegreeRow(index)}
                              />
                            </Col>
                          </Row>
                        ))}
                        <Form.Item>
                          <Button
                            type="link"
                            style={{ width: "130px", height: "45px" }}
                            onClick={handleAddDegree}
                            icon={<PlusCircleFilled />}
                          >
                            Add More
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>

                    <div className="tils">Awards</div>
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        {formData.awards?.map((data, index) => (
                          <Row gutter={24}>
                            <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                              <Form.Item
                                label="Award"
                                name={`awards[${index}].award`}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                              >
                                <Input
                                  name={`awards[${index}].award`}
                                  style={inputField2}
                                  placeholder="Award"
                                  onChange={(e) =>
                                    handleOnChangeAward(e, index, "award")
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                              <Form.Item
                                label="Year"
                                name={`awards[${index}].year`}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                              >
                                <DatePicker
                                  name={`awards[${index}].year`}
                                  onChange={(date, dateString) =>
                                    handleOnChangeAwardYear(
                                      date,
                                      dateString,
                                      index,
                                      "year"
                                    )
                                  }
                                  picker="year"
                                  format="YYYY"
                                  style={inputField2}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                              <DeleteFilled
                                onClick={() => handleOnRemoveAwardRow(index)}
                              />
                            </Col>
                          </Row>
                        ))}
                        <Form.Item>
                          <Button
                            type="link"
                            style={{ width: "130px", height: "45px" }}
                            onClick={handleAddAward}
                            icon={<PlusCircleFilled />}
                          >
                            Add More
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>

                    <div className="tils">Experience</div>
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        {formData.experience.map((data, index) => (
                          <Row gutter={24}>
                            <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                              <Form.Item
                                label="Hospital Name"
                                name={`experience[${index}].hospital_name`}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                              >
                                <Input
                                  name={`experience[${index}].hospital_name`}
                                  style={inputField2}
                                  placeholder="Hospital Name"
                                  onChange={(e) =>
                                    handleOnChangeExperience(
                                      e,
                                      index,
                                      "hospital_name"
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                              <Form.Item
                                label="Year"
                                name={`experience[${index}].year`}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                              >
                                <RangePicker
                                  name={`experience[${index}].year`}
                                  style={inputField2}
                                  placeholder={["Date From", "Date To"]}
                                  onChange={(date, dateString) =>
                                    handleOnChangeExperienceYear(
                                      date,
                                      dateString,
                                      index,
                                      "year"
                                    )
                                  }
                                  format={"DD-MMM-YYYY"}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                              <Form.Item
                                label="College/Institute"
                                name={`experience[${index}].institute`}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                              >
                                <Input
                                  name={`experience[${index}].institute`}
                                  style={inputField2}
                                  placeholder="College/Institute"
                                  onChange={(e) =>
                                    handleOnChangeExperience(
                                      e,
                                      index,
                                      "institute"
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                              <DeleteFilled
                                onClick={() =>
                                  handleOnRemoveExperienceRow(index)
                                }
                              />
                            </Col>
                          </Row>
                        ))}
                        <Form.Item>
                          <Button
                            type="link"
                            style={{ width: "130px", height: "45px" }}
                            onClick={handleAddExperience}
                            icon={<PlusCircleFilled />}
                          >
                            Add More
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </div>
              </Panel> */}
            {/* <Panel header="DCP" key="4"> */}
            {/* <div> */}
            {/* <Card> */}
            {/* <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Type"
                          name="type"
                          rules={[
                            {
                              required: formData.is_dcp_activated === "Yes",
                              message: "Required",
                            },
                          ]}
                        >
                          <Select
                            name="type"
                            placeholder="Select Type"
                            allowClear
                            onChange={(v) => handleSelectChange("type", v)}
                            disabled={formData.is_dcp_activated === "No"}
                          >
                            <Select.Option value={"GC"}>GC</Select.Option>
                            <Select.Option value={"MHC"}>MHC</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      
                    </Row> */}
            {/* <Row gutter={24}>
                      {formData.type === "MHC" && (
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                          <Form.Item
                            label="Expert Type"
                            name="expert_type"
                            rules={[
                              {
                                required: formData.is_dcp_activated === "Yes",
                                message: "Required",
                              },
                            ]}
                          >
                            <Select
                              name="expert_type"
                              placeholder="Select Expert Type"
                              allowClear
                              onChange={(v) =>
                                handleSelectChange("expert_type", v)
                              }
                              disabled={formData.is_dcp_activated === "No"}
                            >
                              {getCommonMasterListState.apiState ===
                                "success" &&
                                _.find(getCommonMasterListState.list, {
                                  slug: "expert-type",
                                }) && (
                                  <>
                                    {_.find(getCommonMasterListState.list, {
                                      slug: "expert-type",
                                    }).common_master_detail.map((item) => (
                                      <Select.Option
                                        value={item._id}
                                        key={item._id}
                                      >
                                        {item.value}
                                      </Select.Option>
                                    ))}
                                  </>
                                )}
                            </Select>
                          </Form.Item>
                        </Col>
                      )}
                      {formData.type === "MHC" && (
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                          <Form.Item
                            label="Consultation Type"
                            name="consultation_type"
                            rules={[
                              {
                                required: formData.is_dcp_activated === "Yes",
                                message: "Required",
                              },
                            ]}
                          >
                            <Select
                              name="consultation_type"
                              placeholder="Select Consultation Type"
                              allowClear
                              onChange={(v) =>
                                handleSelectChange("consultation_type", v)
                              }
                              disabled={formData.is_dcp_activated === "No"}
                            >
                              {getCommonMasterListState.apiState ===
                                "success" &&
                                _.find(getCommonMasterListState.list, {
                                  slug: "consultation-type",
                                }) && (
                                  <>
                                    {_.find(getCommonMasterListState.list, {
                                      slug: "consultation-type",
                                    }).common_master_detail.map((item) => (
                                      <Select.Option
                                        value={item._id}
                                        key={item._id}
                                      >
                                        {item.value}
                                      </Select.Option>
                                    ))}
                                  </>
                                )}
                            </Select>
                          </Form.Item>
                        </Col>
                      )}
                    </Row> */}
            {/* <Row gutter={24}>
                      {formData.type === "MHC" && (
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                          <Form.Item
                            label="Concerns"
                            name="concerns"
                            rules={[
                              {
                                required: formData.is_dcp_activated === "Yes",
                                message: "Required",
                              },
                            ]}
                          >
                            <Select
                              name="concerns"
                              placeholder="Select Concerns"
                              className="multisle"
                              allowClear
                              onChange={(v, node) =>
                                handleSelectChange("concerns", v, node)
                              }
                              showSearch
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              mode="multiple"
                              disabled={formData.is_dcp_activated === "No"}
                            >
                              {getCommonMasterListState.apiState ===
                                "success" &&
                                _.find(getCommonMasterListState.list, {
                                  slug: "concerns",
                                }) && (
                                  <>
                                    {_.find(getCommonMasterListState.list, {
                                      slug: "concerns",
                                    }).common_master_detail.map((item) => (
                                      <Select.Option
                                        value={item._id}
                                        key={item._id}
                                      >
                                        {item.value}
                                      </Select.Option>
                                    ))}
                                  </>
                                )}
                            </Select>
                          </Form.Item>
                        </Col>
                      )}
                      {formData.type === "MHC" && (
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                          <Form.Item
                            label="Expert Approaches"
                            name="expert_approaches"
                            rules={[
                              {
                                required: formData.is_dcp_activated === "Yes",
                                message: "Required",
                              },
                            ]}
                          >
                            <Select
                              name="expert_approaches"
                              placeholder="Select Expert Approaches"
                              allowClear
                              onChange={(v, node) =>
                                handleSelectChange("expert_approaches", v, node)
                              }
                              showSearch
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              mode="multiple"
                              disabled={formData.is_dcp_activated === "No"}
                            >
                              {getCommonMasterListState.apiState ===
                                "success" &&
                                _.find(getCommonMasterListState.list, {
                                  slug: "expert-approaches",
                                }) && (
                                  <>
                                    {_.find(getCommonMasterListState.list, {
                                      slug: "expert-approaches",
                                    }).common_master_detail.map((item) => (
                                      <Select.Option
                                        value={item._id}
                                        key={item._id}
                                      >
                                        {item.value}
                                      </Select.Option>
                                    ))}
                                  </>
                                )}
                            </Select>
                          </Form.Item>
                        </Col>
                      )}
                    </Row> */}
            {/* <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item label="Qualification" name="qualification">
                          <Input
                            name="qualification"
                            placeholder="Enter Qualification"
                            onChange={handleOnChange}
                            style={inputField}
                            disabled={formData.is_dcp_activated === "No"}
                          />
                        </Form.Item>
                      </Col>
                    </Row> */}
            <Row gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                {/* <Form.Item label="Area of Expertise" name="area_of_expertise">
                  <Select
                    name="area_of_expertise"
                    placeholder="Select Area of Expertise"
                    allowClear
                    onChange={(v) => handleSelectChange("area_of_expertise", v)}
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={formData.is_dcp_activated === "No"}
                  >
                    {getCommonMasterListState.apiState === "success" &&
                      _.find(getCommonMasterListState.list, {
                        slug: "area-of-expertise",
                      }) && (
                        <>
                          {_.find(getCommonMasterListState.list, {
                            slug: "expert-approaches",
                          }).common_master_detail.map((item) => (
                            <Select.Option value={item._id} key={item._id}>
                              {item.value}
                            </Select.Option>
                          ))}
                        </>
                      )}
                  </Select>
                </Form.Item> */}
                <Form.Item label="Speciality" name="speciality">
                  <Input
                    name="speciality"
                    placeholder="Enter Speciality"
                    style={inputField}
                    readOnly
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item label="Experience" name="exprience">
                    <Input
                    name="exprience"
                    placeholder="Enter Years of Experience"
                    style={inputField}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Description"
                          name="description"
                          rules={[
                            {
                              required: formData.is_dcp_activated === "Yes",
                              message: "Required",
                            },
                          ]}
                        >
                          <Input.TextArea
                            name="description"
                            style={{ height: "100px", borderRadius: "10px" }}
                            placeholder="Enter Description"
                            onChange={handleOnChange}
                            disabled={formData.is_dcp_activated === "No"}
                          />
                        </Form.Item>
                      </Col> */}

            <ProfileBlankSpace />
            {/* <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Tier 1 fee"
                          name="tier_1_fee"
                          rules={[
                            {
                              required: formData.is_dcp_activated === "Yes",
                              message: "Required",
                            },
                          ]}
                        >
                          <InputNumber
                            name="tier_1_fee"
                            placeholder="Enter Tier 1 fee"
                            onChange={(v) =>
                              handleNumberChange("tier_1_fee", v)
                            }
                            style={inputField}
                            disabled={formData.is_dcp_activated === "No"}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Tier 2 fee"
                          name="tier_2_fee"
                          rules={[
                            {
                              required: formData.is_dcp_activated === "Yes",
                              message: "Required",
                            },
                          ]}
                        >
                          <InputNumber
                            name="tier_2_fee"
                            placeholder="Enter Tier 2 fee"
                            onChange={(v) =>
                              handleNumberChange("tier_2_fee", v)
                            }
                            style={inputField}
                            disabled={formData.is_dcp_activated === "No"}
                          />
                        </Form.Item>
                      </Col>
                    </Row> */}

            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item label="Core Area" name="core_area">
                          <Select
                            name="core_area"
                            placeholder="Select Core Area"
                            allowClear
                            onChange={(v) => handleSelectChange("core_area", v)}
                            showSearch
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            disabled={formData.is_dcp_activated === "No"}
                          >
                            {getCommonMasterListState.apiState === "success" &&
                              _.find(getCommonMasterListState.list, {
                                slug: "core-area",
                              }) && (
                                <>
                                  {_.find(getCommonMasterListState.list, {
                                    slug: "core-area",
                                  }).common_master_detail.map((item) => (
                                    <Select.Option
                                      value={item._id}
                                      key={item._id}
                                    >
                                      {item.value}
                                    </Select.Option>
                                  ))}
                                </>
                              )}
                          </Select>
                        </Form.Item>
                      </Col> */}
            {/* <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Can give Medicine"
                          name="can_give_medicine"
                        >
                          <Switch
                            checkedChildren="Yes"
                            unCheckedChildren="No"
                            onChange={(checked) =>
                              handleSwitchChange(
                                "can_give_medicine",
                                checked ? "Yes" : "No"
                              )
                            }
                            disabled={formData.is_dcp_activated === "No"}
                            checked={formData.can_give_medicine === "Yes"}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item label="Self Fee" name="self_fee">
                          <InputNumber
                            name="self_fee"
                            placeholder="Enter Self Fee"
                            onChange={(v) => handleNumberChange("self_fee", v)}
                            style={inputField}
                            disabled={formData.is_dcp_activated === "No"}
                          />
                        </Form.Item>
                      </Col>
                    </Row> */}
            {/* <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item label="Couple Fee" name="couple_fee">
                          <InputNumber
                            name="couple_fee"
                            placeholder="Enter Couple Fee"
                            onChange={(v) =>
                              handleNumberChange("couple_fee", v)
                            }
                            style={inputField}
                            disabled={formData.is_dcp_activated === "No"}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item label="Family Fee" name="family_fee">
                          <InputNumber
                            name="family_fee"
                            placeholder="Enter Family Fee"
                            onChange={(v) =>
                              handleNumberChange("family_fee", v)
                            }
                            style={inputField}
                            disabled={formData.is_dcp_activated === "No"}
                          />
                        </Form.Item>
                      </Col>
                    </Row> */}
            {/* <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item label="Medicine Fee" name="medicine_fee">
                          <InputNumber
                            name="medicine_fee"
                            placeholder="Enter Medicine Fee"
                            onChange={(v) =>
                              handleNumberChange("medicine_fee", v)
                            }
                            style={inputField}
                            disabled={formData.is_dcp_activated === "No"}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item label="Hidden" name="hidden">
                          <Switch
                            checkedChildren="Yes"
                            unCheckedChildren="No"
                            onChange={(checked) =>
                              handleSwitchChange(
                                "hidden",
                                checked ? "Yes" : "No"
                              )
                            }
                            disabled={formData.is_dcp_activated === "No"}
                            checked={formData.hidden === "Yes"}
                          />
                        </Form.Item>
                      </Col>
                    </Row> */}
            {/* <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          label="Short Description"
                          name="short_description"
                          rules={[
                            {
                              required: formData.is_dcp_activated === "Yes",
                              message: "Required",
                            },
                          ]}
                        >
                          <Input.TextArea
                            name="short_description"
                            style={{
                              borderRadius: "10px",
                              width: "100%",
                              height: "100px",
                            }}
                            placeholder="Enter Short Description"
                            onChange={handleOnChange}
                            disabled={formData.is_dcp_activated === "No"}
                          />
                        </Form.Item>
                      </Col>
                    </Row> */}
            {/* </Card>
                </div>
              </Panel> */}
            {/* <Panel header="Social Media Accounts" key="5">
                <div>
                  <Card>
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          name="facebook_id"
                          label="Facebook"
                          rules={[
                            { required: false, message: " Required" },
                            {
                              pattern: "",
                              message: "Name is not valid",
                            },
                          ]}
                        >
                          <Input
                            name="facebook_id"
                            placeholder="Enter facebook id"
                            onChange={dochange}
                            style={inputField}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          name="instagram_id"
                          label="Instagram"
                          rules={[
                            { required: false, message: " Required" },
                            {
                              pattern: "",
                              message: "Name is not valid",
                            },
                          ]}
                        >
                          <Input
                            name="instagram_id"
                            placeholder="Enter Instagram id"
                            onChange={dochange}
                            style={inputField}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                          name="linkedin_id"
                          label="LinkedIn"
                          rules={[
                            { required: false, message: " Required" },
                            {
                              pattern: "",
                              message: "Name is not valid",
                            },
                          ]}
                        >
                          <Input
                            name="linkedin_id"
                            placeholder="Enter LinkedIn id"
                            onChange={dochange}
                            style={inputField}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </div>
              </Panel> */}
            {/* </Collapse> */}

            {/* <div className="container SaveProfileAction"> */}
              <Row >
                <Col xs={8} sm={12} md={12} lg={12} xl={12} style={{ paddingLeft:"0" }}>
                  <Form.Item name="save" wrapperCol={{ ...layout.wrapperCol }}>
                    {/* <Button
                          shape="rectangle"
                          size="large"
                          type="primary"
                          htmlType="submit"
                        >
                          Save */}
                    <Button shape="rectangle" type="primary" htmlType="submit">
                      Save
                    </Button>
                  </Form.Item>
                </Col>

                <Col
                  xs={16}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  style={{ textAlign: "right", paddingRight:"0" }}
                >
                  <Form.Item name="ResetPassword">
                    <Button
                      shape="rectangle"
                      type="primary"
                      onClick={showModal}
                    >
                      Reset Password
                    </Button>
                    <Modal
                      title="Reset Password"
                      style={{ top: 20 }}
                      visible={isModalVisible}
                      okText="Confirm"
                      onOk={onConfirm}
                      onCancel={handleCancel}
                    >
                      <Form form={form2} layout="vertical" onFinish={onConfirm}>
                        <Row gutter={24}>
                          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Form.Item
                              label="Previous Password"
                              name="password"
                              rules={[
                                { required: true, message: "Required" },
                                {
                                  pattern: "",
                                  message: "enter valid!",
                                },
                              ]}
                            >
                              <Input.Password
                                placeholder="Previous Password"
                                name="password"
                                type="password"
                                style={inputField}
                                onChange={modalchange}
                              />
                            </Form.Item>
                          </Col>
                          <ProfileBlankSpace />

                          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Form.Item
                              label="New Password"
                              name="newPassword1"
                              rules={[
                                { required: true, message: "Required" },
                                {
                                  pattern: "",
                                  message: "enter valid!",
                                },
                              ]}
                            >
                              <Input.Password
                                placeholder="New password"
                                name="newPassword1"
                                type="password"
                                style={inputField}
                                onChange={modalchange}
                              />
                            </Form.Item>
                          </Col>
                          <ProfileBlankSpace />

                          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Form.Item
                              label="Confirm new Password"
                              name="newPassword2"
                              rules={[
                                { required: true, message: "Required" },
                                {
                                  pattern: "",
                                  message: "enter valid!",
                                },
                              ]}
                            >
                              <Input.Password
                                placeholder="confirm new password"
                                name="newPassword2"
                                type="password"
                                style={inputField}
                                onChange={modalchange}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    </Modal>
                  </Form.Item>
                </Col>
              </Row>
            {/* </div> */}
          </Form>
        </div>
      </PageContainer>
    </>
  );
};

const mapStateToProps = (state) => ({
  getDoctorDetailState: state.getDoctorDetail,
  updateDoctorDetailState: state.updateDoctorDetail,
  resetPasswordState: state.resetPassword,
  getCommonMasterListState: state.getCommonMasterList,
});

const mapDispatchToProps = (dispatch) => ({
  getDoctorDetail: (params) => dispatch(getDoctorDetail(params)),
  updateDoctorDetail: (params) => dispatch(updateDoctorDetail(params)),
  resetPassword: (params) => dispatch(resetPassword(params)),
  resetPasswordResetState: () => dispatch(resetPasswordResetState()),
  updateDoctorDetailResetState: () => dispatch(updateDoctorDetailResetState()),
  getDoctorDetailReset: () => dispatch(getDoctorDetailReset()),
  getCommonMasterList: (params) => dispatch(getCommonMasterList(params)),
  getCommonMasterListReset: () => dispatch(getCommonMasterListReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileSetting);
